import React from "react";
import Heading from "../components/NewUi/heading/Heading";
import AppointmentIcon from "../assets/Updated-imagery/appointment_icon.png";
import moment from "moment";
import Button from "../components/ui/Button";
import { printFullDateTime } from "../utils/time";
import { printRelativeDate } from "../utils/ar";
import { useLanguage } from "../context/LanguageContext";

const UpcomingLiveSessions = ({ UpcomingLiveSessions = [], isHomeSection = true }) => {
    const { language } = useLanguage();
    const content = {
        headingTitle: {
            en: "Follow Your Sessions",
            ar: "تابع جلساتك",
        },
        headingSubtitle: {
            en: "Booked",
            ar: "المحجوزة",
        },
        noSessionsMessage: {
            en: "You currently don't have any booked session appointments.",
            ar: "مفيش ليك مواعيد جلسات محجوزة حاليا",
        },
        reminder: {
            text: {
                en: "Please ensure you attend your booked sessions on time to benefit fully.",
                ar: "لازم تخلي بالك من الجلسات اللي محجوزه عندك علشان تقدر تستفيد منها وتحضرها في موعدها المحدد وتستفيد منها بشكل كامل.  !",
            },
            highlight: {
                en: " If you miss a session, it will be considered an absence and cannot be compensated.",
                ar: "خلي بالك لو محضرتش الجلسة المحجوزة في موعدها المحدد هتتحسب عليك كغياب و مش هتقدر تعوضها",
            },
        },
        sessionTime: {
            en: "Session Time",
            ar: "معاد الجلسة",
        },
        sessionTitle: {
            en: "Session Title:",
            ar: "عنوان الجلسة المباشرة:",
        },
        assistantTeacher: {
            en: "Assistant Teacher:",
            ar: "المدرس المٌساعد:",
        },
        note: {
            en: "Note:",
            ar: "ملحوظة:",
        },
        sessionLink: {
            en: "Join Session",
            ar: "لينك الجلسة",
        },
        sessionExpired: {
            en: "Session Expired",
            ar: "انتهت الجلسة",
        },
    };

    return (
        <div className={`flex-col flex-center-both space-y-5`}>
            <Heading
                title={content.headingTitle[language]}
                subtitle={content.headingSubtitle[language]}
            />
            <p className="text-gray-700 text-center w-full md:w-2/3 dark:text-gray-200 smooth">
                {isHomeSection ? "" : <div>{content.reminder.text[language]}</div>}
                <div className="font-w-bold">{content.reminder.highlight[language]}</div>
            </p>

            {UpcomingLiveSessions && UpcomingLiveSessions.length > 0 ? (
                <div className="w-full flex-center-both flex-col">
                    <div className="grid grid-cols-1 w-full gap-4 ">
                        {UpcomingLiveSessions.map((liveAttendance) => (
                            <div
                                className="flex-center-both  flex-col space-y-5  bg-[#F1FBFE] border border-black rounded-3xl py-5 px-3 dark:bg-ashGray-100 smooth "
                                key={liveAttendance.live_session.id}
                            >
                                <div className="w-full flex flex-col space-y-3">
                                    <h3 className="font-bold clr-text-primary smooth text-center w-full text-lg mb-2 flex-center-both flex-col">
                                        <div className="text-ashGray-300 dark:text-ashGray-800 smooth font-w-bold">
                                            {content.sessionTime[language]}:
                                        </div>{" "}
                                        <div className="bg-sky-500 text-white px-2 rounded-md flex-center-both flex-col">
                                            <span className="font-w-bold">
                                                {printRelativeDate(
                                                    liveAttendance.live_session.session_date
                                                )}
                                            </span>
                                            <span className="">
                                                {printFullDateTime(
                                                    liveAttendance.live_session.session_date,
                                                    language
                                                )}
                                            </span>
                                        </div>
                                    </h3>
                                    <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                        <strong className="text-ashGray-300 dark:text-ashGray-800 smooth">
                                            {content.sessionTitle[language]}
                                        </strong>{" "}
                                        {liveAttendance.live_session.name}
                                    </p>
                                    <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                        <strong className="text-ashGray-300 dark:text-ashGray-800 smooth">
                                            {content.assistantTeacher[language]}
                                        </strong>{" "}
                                        {liveAttendance.live_session.admin?.full_name}
                                    </p>
                                    <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                        <strong className="text-ashGray-300 dark:text-ashGray-800 smooth">
                                            {content.note[language]}
                                        </strong>{" "}
                                        {liveAttendance.live_session.description}
                                    </p>
                                    {/* <p className="text-sm text-gray-700 dark:text-gray-300 smooth">
                                        <strong className="text-ashGray-300 dark:text-ashGray-800 smooth">
                                            الحد الأقصي المسموح به:
                                        </strong>{" "}
                                        {liveAttendance.live_session.maximum_attendance}
                                    </p> */}
                                    {moment(liveAttendance.live_session.session_date).isSame(
                                        moment(),
                                        "day"
                                    ) &&
                                        liveAttendance.live_session.session_url &&
                                        (() => {
                                            const isSessionExpired = moment().isAfter(
                                                moment(
                                                    liveAttendance.live_session.session_date
                                                ).add(
                                                    liveAttendance.live_session.duration_in_minutes,
                                                    "minutes"
                                                )
                                            );
                                            return (
                                                <Button
                                                    href={liveAttendance.live_session.session_url}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    element="a"
                                                    color="sky"
                                                    className={`text-center ${
                                                        isSessionExpired
                                                            ? "opacity-50 pointer-events-none cursor-not-allowed"
                                                            : ""
                                                    }`}
                                                    onClick={(e) => {
                                                        if (isSessionExpired) {
                                                            e.preventDefault();
                                                            return;
                                                        }
                                                    }}
                                                >
                                                    {isSessionExpired
                                                        ? {
                                                              content:
                                                                  content.sessionExpired[language],
                                                          }
                                                        : {
                                                              content:
                                                                  content.sessionLink[language],
                                                          }}
                                                </Button>
                                            );
                                        })()}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            ) : (
                <div className="w-full flex-center-both  flex-col space-y-5  bg-[#FFF7CC] border border-black rounded-3xl py-5 px-20 dark:bg-secYellow-200 smooth ">
                    <img src={AppointmentIcon} alt="inputDateIcon" className="w-20 h-auto" />
                    <span className="w-3/4 font-h2 text-center">
                        {content.noSessionsMessage[language]}
                    </span>
                </div>
            )}
        </div>
    );
};

export default UpcomingLiveSessions;
